import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";

const httpLink = new createHttpLink({
  uri: process.env.NEXT_PUBLIC_GQL_URL,
  credentials: "include",
});

const cache = new InMemoryCache({ addTypename: false });

const client = new ApolloClient({
  link: httpLink,
  cache,
});

export default client;
